module.exports = __webpack_public_path__ + "img/hr-fast-splitter-west.fa8f9aa8.png";